import React from 'react'
import {Container} from '@mui/material'

export default function OrderOut(){
    return (
        <Container>
            Изнасяне поръчки
        </Container>
    )
}